module.exports = __webpack_public_path__ + "img/logo.81a71f70.png";